import { createStoreWithSelectors } from 'common/util/zustand';
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
const polygonEventStore = create(subscribeWithSelector((set) => ({
    hoveredPolygonIndex: -1,
    setHoveredPolygonIndex: (activeIndex) => set(() => ({ hoveredPolygonIndex: activeIndex })),
    clickedPolygonIndex: -1,
    setClickedPolygonIndex: (activeIndex) => set(() => ({ clickedPolygonIndex: activeIndex })),
    hoveredLotId: '',
    setHoveredLotId: (hoveredLotId) => {
        set(() => ({ hoveredLotId: hoveredLotId }));
    },
    clickedLotId: '',
    setClickedLotId: (clickedLotId) => {
        set(() => ({ clickedLotId: clickedLotId }));
    }
})));
const usePolygonEventStore = createStoreWithSelectors(polygonEventStore);
export default usePolygonEventStore;
